// Tier 2 (INTERMEDIATE — SuPER System) — 25 lessons across modules 2.1–2.5.
// Static imports so the PWA bundles lesson data at build time (zero network calls, works offline).
import lessonsT2_1to2 from "./axel-lessons-2.1.1-to-2.2.5.json";
import lessonsT2_3to4 from "./axel-lessons-2.3.1-to-2.4.5.json";
import lessonsT2_5 from "./axel-lessons-2.5.1-to-2.5.5.json";
import { normalizeLesson } from "./normalizeQuiz";

const unwrap = (src) => (Array.isArray(src) ? src : src?.lessons || []);

export const TIER2_LESSONS = [
  ...unwrap(lessonsT2_1to2),
  ...unwrap(lessonsT2_3to4),
  ...unwrap(lessonsT2_5),
].map(normalizeLesson);
